module.exports = __webpack_public_path__ + "media/images/team-d88bcad642e675db984607b2b798d096.png";